import React from 'react';

import { Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    className?: string;
}

const WebApplicability: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement="bottom-start"
            title={
                <span className={classes.content}>{'This vulnerability affects specific URLs on the web server'}</span>
            }
        >
            <span className={cx(classes.container, className)}>{'🌐 WEB'}</span>
        </Tooltip>
    );
};

export default WebApplicability;
